import authenticatedEligibilityApi from "../utils/eligibilityApi";
import { API_ROUTES } from "../route.constants";

export const SUBMIT_CLIENT_DETAILS = API_ROUTES.SUBMIT;
export const getLoanReasons = () =>
  authenticatedEligibilityApi.get(API_ROUTES.LOAN_REASONS);
